import { FuelCard, FuelCardProvider } from '../redux/api/fuelcard/fuelcard.model';
import { TwAutocompleteOption } from '../components/TwAutocomplete/TwAutocomplete';

export enum FuelCardEntity {
  DRIVER = 'driver',
  EQUIPMENT = 'equipment'
}

class FuelcardUtils {
  static generateFuelCardOptionLabel = (card: FuelCard): string => {
    return `${card.provider || FuelCardProvider.EFS} | #${card.card_number}`;
  };

  static mapFuelcardToAutocompleteOption(
    fuelcard: FuelCard,
    forEntity: FuelCardEntity = FuelCardEntity.DRIVER
  ): TwAutocompleteOption {
    return {
      id: fuelcard.id,
      label: FuelcardUtils.generateFuelCardOptionLabel(fuelcard),
      value: fuelcard.id,
      endAdornmentIcon:
        forEntity === FuelCardEntity.DRIVER
          ? fuelcard.driver_id
            ? 'Assigned'
            : undefined
          : fuelcard.truck_id
          ? 'Assigned'
          : undefined,
      dimmed: forEntity === FuelCardEntity.DRIVER ? !!fuelcard.driver_id : !!fuelcard.truck_id
    };
  }
}

export default FuelcardUtils;
